import { FC, useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { Button as AntButton, Modal } from 'antd';
import NoticeEditor from "../NoticeEditor";
import useAxios from "../../../../hooks/useAxios";
import Loader from "../../../Loader";
import ErrorResponse from "../../../ErrorResponse";
import { createNotification } from "../../../../api/notification.api";
import useNotification from "../../../../hooks/useNotification";

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  event: any;
  doGetClassNotice: () => void;
  isTutor?: boolean;
  className?: string|undefined;
}

const CreateNoticeModal: FC<IProps> = ({
  visible,
  setVisible,
  event,
  doGetClassNotice,
  isTutor = false,
  className,
}) => {
  const { t } = useTranslation();
  const { successNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios();
  const [toSubmit, setToSubmit] = useState(false);

  useEffect(() => {
    if (res && !isLoading) {
      doGetClassNotice();
      successNotification(t('common.message.save1'));
      setVisible(false);
    }
  }, [res, isLoading]);

  const submit = (data: FormData) => {
    execute(createNotification(data));
  }

  return (
    <>
      { isLoading ? <Loader /> : null }
      <ErrorResponse error={error} />

      <Modal
        title={t('class.class.title14')}
        visible={visible}
        width={750}
        onCancel={() => setVisible(false)}
        footer={[
          <div className='comm-btn__area justify-content-center'>	
            <AntButton
              key="submit"
              className='btn-basic pink'
              onClick={() => setToSubmit(true)}
            >
              {t('common.button.save')}
            </AntButton>
            <AntButton
              key="cancel"
              className='btn-basic gray'
              onClick={() => setVisible(false)}
            >
              {t('common.button.close')}
            </AntButton>
          </div>
        ]}
      >
        <NoticeEditor
          event={event}
          submit={submit}
          toSubmit={toSubmit}
          setToSubmit={setToSubmit}
          isTutor={isTutor}
          className={className}
        />
      </Modal>
    </>
  );
}

export default CreateNoticeModal;
